import React from 'react';
import { useEnvironment } from '@wix/yoshi-flow-editor';

import { ELayoutType } from 'settings/constants';
import { Box } from 'wui/Box';
import { type TPAComponentProps } from 'wui/types';

import { Header } from '../Header';
import { PendingGroups } from '../../PendingGroups';

import { Groups } from './Groups';

import { FeedWithTitle } from '../FeedWithTitle';

export function GridLayout(props: TPAComponentProps) {
  const { isMobile } = useEnvironment();

  return (
    <Box gap={isMobile ? 'SP0' : 'SP6'} direction="vertical" {...props}>
      <Header origin="horizontal_group_list" data-hook="grid-layout-header" />
      <PendingGroups data-hook="pending-groups" />
      <Groups data-hook="groups" />
      <FeedWithTitle data-hook="feed-with-title" />
    </Box>
  );
}

GridLayout.displayName = 'GridLayout';
